import React, { useContext } from 'react'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import FavoriteIcon from '@mui/icons-material/Favorite'
import SearchContext from '../../context/SearchContext'
import Statusbar from '../generic/Statusbar'
import Tooltip from '@mui/material/Tooltip'
import {
  addFavorite,
  removeFavorite,
  isFavorite,
} from '../../lib/favorites_hook'
import { buildSku } from '../../utils/ProductUtils'
import { trackEvent } from '../../utils/ArtboxoneTracking'
import { useTranslation } from 'react-i18next'

interface FavoriteProps {
  motiveId: number
  material: string
  ratio: number
  show: boolean
}

const Favorite: React.FC<FavoriteProps> = ({
  motiveId,
  material,
  ratio,
  show,
}) => {
  motiveId = parseInt('' + motiveId)
  const { favoritesCount, setFavoritesCount } = useContext(SearchContext)

  const { t } = useTranslation('translation')

  const handleFavClick = (event: React.MouseEvent<SVGElement, MouseEvent>) => {
    event.preventDefault()
    event.stopPropagation()

    setOpen(true)

    let fc = favoritesCount

    if (favorite) {
      fc -= 1
      removeFavorite(motiveId, material, ratio)

      trackEvent({
        category: 'favorite',
        action: 'remove',
        label: buildSku(material, motiveId),
      })
    } else {
      fc += 1
      addFavorite(motiveId, material, ratio)

      trackEvent({
        category: 'favorite',
        action: 'add',
        label: buildSku(material, motiveId),
      })
    }

    setFavorite(!favorite)
    setFavoritesCount(fc)
  }

  const [favorite, setFavorite] = React.useState(
    isFavorite(motiveId, material, ratio),
  )
  const [open, setOpen] = React.useState(false)

  let icon = (
    <FavoriteBorderIcon className="iconButton" onClick={handleFavClick} />
  )
  let message = t('Aus Favoriten entfernt')
  let tooltipTitle = t('Als Favorit festlegen')

  if (favorite) {
    icon = <FavoriteIcon className="iconButton" onClick={handleFavClick} />
    message = t('Als Favorit gespeichert')
    tooltipTitle = t('Aus Favoriten entfernen')
  }

  if (!show) {
    return (
      <div>
        <svg
          aria-hidden="true"
          className="MuiSvgIcon-root iconButton"
          focusable="false"
          role="presentation"
          viewBox="0 0 24 24"
        >
          <path d=""></path>
        </svg>
      </div>
    )
  } else {
    return (
      <>
        <Tooltip title={tooltipTitle}>{icon}</Tooltip>
        <Statusbar message={message} open={open} setOpen={setOpen} />
      </>
    )
  }
}

export default Favorite
